import React, { createContext, useContext, useState, useCallback } from 'react';

const SampleCartContext = createContext(null);

export function SampleCartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const addItem = useCallback((finish) => {
    setItems(prev => {
      if (prev.find(i => i.id === finish.id)) return prev;
      return [...prev, { id: finish.id, name: finish.name, code: finish.code || '', category: finish.category || '', image: finish.image || '', colorHex: finish.colorHex || '#999' }];
    });
  }, []);

  const removeItem = useCallback((id) => {
    setItems(prev => prev.filter(i => i.id !== id));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);
  const isInCart = useCallback((id) => items.some(i => i.id === id), [items]);
  const toggleDrawer = useCallback(() => setIsOpen(prev => !prev), []);
  const openDrawer = useCallback(() => setIsOpen(true), []);
  const closeDrawer = useCallback(() => setIsOpen(false), []);

  return (
    <SampleCartContext.Provider value={{ items, addItem, removeItem, clearCart, isInCart, isOpen, toggleDrawer, openDrawer, closeDrawer }}>
      {children}
    </SampleCartContext.Provider>
  );
}

export function useSampleCart() {
  const ctx = useContext(SampleCartContext);
  if (!ctx) throw new Error('useSampleCart must be used within SampleCartProvider');
  return ctx;
}
